<template>
  <section data-anim-wrap class="pageHeader -type-1 tw-h-[75vh]">
    <div data-anim-child="fade delay-1" class="pageHeader__image">
      <NuxtImg
        :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
        alt="Background Image"
        class="tw-h-full tw-w-full tw-object-cover tw-object-top"
      />
    </div>

    <div class="container tw-text-center">
      <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>
      
      <div class="tw-relative tw-z-10 tw-flex tw-h-full tw-w-full tw-items-end tw-justify-center">
        <div
          class="tw-z-100 tw-mx-2 tw-mb-4 tw-flex tw-w-full tw-flex-col tw-gap-6 tw-text-center tw-text-white md:tw-mx-12 md:tw-mb-8 xl:tw-mb-24 xl:tw-gap-6"
        >
          <h1>{{ vars.titleText }}</h1>

          
          <h6
            v-if="vars.descriptionText"
            class="tw-mb-4 tw-max-w-2xl tw-text-white tw-text-center mx-auto"
          >
            {{ vars.descriptionText }}
      </h6>

         
          <div
            class="tw-flex tw-justify-center tw-gap-3 tw-text-center max-sm:tw-flex-col sm:tw-items-center lg:tw-gap-5"
          >
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="index"
              :external="true"
              :target="isExternalLink(button.link) ? '_blank' : '_self'"
              :to="button.link"
              :class="`n-${button.type}`"
            >
              {{ button.label }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'IntroSection',

  mixins: [ComponentMixin],


   computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  methods: {
    isExternalLink(link: string) {
      return link.includes('http');
    },
  },
  
});
</script>
